
















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import Loader from '@/components/Loader.vue';
import TaxcardEntry from '@/views/taxcard/transaction-overview/TaxcardEntry.vue';
import TransferredTaxcardEntry from '@/views/taxcard/transaction-overview/TransferredTaxcardEntry.vue';
import moment, { Moment } from 'moment';
import i18next from 'i18next';
import TicketSelectOverlay from '@/views/taxcard/transaction/TicketSelectOverlay.vue';
import WalletButton from '@/components/qr/WalletButton.vue';
import { GuestTypesEnum } from '@/types/taxcard/GuestType';

@Component({
  components: { TicketSelectOverlay, TransferredTaxcardEntry, TaxcardEntry, Loader, NewTranslation, WalletButton },
})
export default class TransactionCard extends Vue {
  @Prop(Object)
  transaction!: any;

  @Prop(String)
  openTransactionTaxId!: string;

  @Prop(Boolean)
  isTransactionCanceling!: false;

  @Prop(Object)
  communeInfo!: any;

  isOpen = false;

  isTicketSelectOpen = false;

  public get transferClass() {
    const { transaction } = this;

    return {
      'is-open': this.isOpen || this.isDigitallyBlocked,
      'is-passive': !this.canPrint && transaction.validity !== 'current',
      'is-printed': this.somePrinted,
      'is-current': transaction.validity === 'current',
      'is-past': transaction.validity === 'past',
      'is-future': transaction.validity === 'future',
      'is-pending': transaction.validity === 'pending',
    };
  }

  public get showDuration() {
    return moment(this.transaction.stayBegin).isValid() && moment(this.transaction.stayEnd).isValid();
  }

  public get showTransactionActions() {
    return this.transaction.validity !== 'past' && this.transaction.validity !== 'pending';
  }

  public get transactionDate() {
    const { transaction } = this;
    return moment(transaction.stayBegin).isSame(moment(transaction.stayEnd))
      ? this.formatDate(moment(transaction.stayBegin))
      : this.formatDate(moment(transaction.stayBegin)) + ' - ' + this.formatDate(moment(transaction.stayEnd));
  }

  public get canCancel() {
    return (
      !this.transaction.cancelRequested &&
      (this.transaction.validity !== 'current' || this.transaction.validity === 'past')
    );
  }

  public get canView() {
    return !this.hasCityTourTaxcard && this.transaction.validity === 'current' && this.eligibleTaxcards.length > 0;
  }

  public get canShare() {
    const validStatus = ['ACTIVE', 'NOT_CANCELLED', 'APPROVED'];

    return (
      !this.hasCityTourTaxcard &&
      (this.transaction.validity === 'current' || this.transaction.validity === 'future') &&
      this.eligibleTaxcards.some((taxcard: any) => validStatus.includes(taxcard.status))
    );
  }

  public get canPrint(): boolean {
    const validStatus = ['ACTIVE', 'NOT_CANCELLED', 'APPROVED', 'PRINTED'];
    return !this.hasCityTourTaxcard && this.eligibleTaxcards.some((taxcard: any) => validStatus.includes(taxcard.status));
  }

  public get visibleTaxcards(): any[] {
    return (this.transaction.taxcards || []).filter((taxcard: any) => !taxcard.digitalOutputBlocked);
  }

  public get eligibleTaxcards(): any[] {
    return this.visibleTaxcards;
  }

  public get isDigitallyBlocked(): boolean {
    return (this.transaction.taxcards || []).some((taxcard: any) => taxcard.digitalOutputBlocked);
  }

  public get isCollapsible(): boolean {
    return !this.isDigitallyBlocked;
  }

  public get firstEligibleTaxcard(): any | null {
    return this.eligibleTaxcards.length > 0 ? this.eligibleTaxcards[0] : null;
  }

  public get hasExternalReference() {
    return this.transaction.taxcards.some((tc: any) => !!tc.externReference);
  }

  public get hasOvernightCards() {
    return this.transaction.taxcards.some((tc: any) => tc.stayGuestType === GuestTypesEnum.overnight);
  }

  public get hasRidingTollTicketSubGuestType() {
    return this.transaction.taxcards.some((tc: any) => tc.subGuestType === 'ridingTollTicket');
  }

  public get hasCityTourTaxcard() {
    return (this.transaction.taxcards || []).some((tc: any) => tc.subGuestType === 'cityTour');
  }

  public get somePrinted() {
    const printedStatus = 'PRINTED';
    return this.transaction.taxcards.some((taxcard: any) => taxcard.status === printedStatus);
  }

  public toggleTransactionOpen(): void {
    if (!this.isCollapsible) {
      this.isOpen = true;
      return;
    }
    this.isOpen = !this.isOpen;
  }

  public formatDate(date: string | Moment): string {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(i18next.t('common.date.format.short')) : 'Ungültiges Datum';
  }

  public onShowClick() {
    this.$emit('show-click');
  }

  public onCancelClick() {
    this.$emit('cancel-click');
  }

  public onPrintClick() {
    this.$emit('print-click');
  }

  public onExternalReferenceClick() {
    this.$emit('external-reference-click');
  }

  public openSharingOverlay() {
    // @ts-ignore
    this.$parent.$parent.$refs.easyRefresh.scrollTo(0, 0);
    this.isTicketSelectOpen = true;
  }

  public isShareableTaxcard(taxcard: any) {
    return this.canShare && !taxcard.digitalOutputBlocked;
  }

  public onShareSelect({ ticketIds, mail, mailOnly }: { ticketIds: number[]; mail: string; mailOnly?: boolean }) {
    this.isTicketSelectOpen = false;
    if (!ticketIds || ticketIds.length === 0) {
      return;
    }
    const taxIds = this.eligibleTaxcards.filter((x: any) => ticketIds.includes(x.id)).map((x: any) => x.taxId);
    this.$emit('share-click', { taxIds, mail, mailOnly });
  }
}
